<template>
  <v-dialog v-model="showOrderPrepDatePicker" width="95%" max-width="400px">
    <v-date-picker
      v-model="orderPrepSearchDate"
      :events="itemAvailabilityMarkers"
      color="blue darken-2"
      event-color="green lighten-1"
      full-width
      @change="showOrderPrepDatePicker = false"
    >
      <v-spacer></v-spacer>
      <v-btn class="blue--text text--darken-1" @click="clear" text>Clear</v-btn>
      <v-btn
        class="blue--text text--darken-2"
        @click="showOrderPrepDatePicker = false"
        text
        >Cancel</v-btn
      >
    </v-date-picker>
  </v-dialog>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'

import _uniq from 'lodash/uniq'
import _reduce from 'lodash/reduce'
import _get from 'lodash/get'

export default {
  name: 'OrderPrepDatePicker',
  components: {},
  data() {
    return {}
  },
  methods: {
    clear() {
      this.orderPrepSearchDate = null
      this.showOrderPrepDatePicker = false
    },
  },
  computed: {
    ...mapFields('admin', ['orderPrepSearchDate', 'showOrderPrepDatePicker']),
    ...mapGetters('itemAndSection', ['getSections']),
    itemAvailabilityMarkers() {
      return _uniq(
        _reduce(
          this.sections,
          (dates, section) => [
            ...dates,
            ..._get(section, 'items', []).map((i) => i.date),
          ],
          []
        )
      )
    }, // itemAvailabilityMarkers
    sections() {
      return this.getSections
    }, // sections
  },
}
</script>
